import { Modal, Box, Typography } from '@mui/material'
import { styled } from '@mui/system'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
  borderRadius: '8px',
  outline: 'none',
}

const CustomCircularProgress = styled('div')({
  display: 'inline-block',
  position: 'relative',
  width: 40,
  height: 40,
  '& div': {
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    width: 32,
    height: 32,
    margin: 4,
    border: '4px solid #000',
    borderRadius: '50%',
    animation: 'lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
    borderColor: '#000 transparent transparent transparent',
  },
  '& div:nth-of-type(1)': {
    animationDelay: '-0.45s',
  },
  '& div:nth-of-type(2)': {
    animationDelay: '-0.3s',
  },
  '& div:nth-of-type(3)': {
    animationDelay: '-0.15s',
  },
  '@keyframes lds-ring': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
})

const LoadingModal = ({ open = true, handleClose }: any) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="loading-modal-title"
      aria-describedby="loading-modal-description"
      disableEnforceFocus>
      <Box sx={style}>
        <CustomCircularProgress>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </CustomCircularProgress>
        <Typography
          id="loading-modal-title"
          variant="h6"
          sx={{ mt: 2, color: 'green' }}>
          Redirecting...
        </Typography>
        <Typography id="loading-modal-description" sx={{ mt: 2 }}>
          please do not <strong style={{ color: 'orange' }}>close</strong> or{' '}
          <strong style={{ color: 'orange' }}>refresh</strong> the window, we
          are redirecting you to link the payments selected
        </Typography>
      </Box>
    </Modal>
  )
}
export default LoadingModal
